import { render, staticRenderFns } from "./ArticlesSection.vue?vue&type=template&id=538a16b0"
import script from "./ArticlesSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports